import { APICore } from './apiCore';

const api = new APICore();

// account
function templates(params: FormData) {
    const baseUrl = '/templates/';
    return api.create(`${baseUrl}`, params);
}
function showTemplates(){
    const baseUrl = '/templates/show';
    return api.show(`${baseUrl}`);
}
function ViewTemplates(TemplateId:string){
    const baseUrl = `/templates/view/${TemplateId}`;
    return api.show(baseUrl);
}

function syncTemplates(companyId: string) {
    const baseUrl = `/templatesync/${companyId}`;
    return api.create(`${baseUrl}`, companyId);
}
function deleteTemplate(templateId: number) {
    const baseUrl = `/templates/${templateId}`;
    return api.delete(baseUrl);
}
export { templates, showTemplates, syncTemplates,ViewTemplates, deleteTemplate };

